<template>
  <div class="sub-content">
    <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class="grid-wrap">
      <dx-data-grid
        ref="refCoilPlanAndInputGrid"
        :data-source="coilPlanAndInputInfo"
        :show-borders="true"
        :showRowLines="false"
        :showColumnLines="true"
        :hover-state-enabled="true"
        :allowColumnResizing="true"
        column-resizing-mode="widget"
        :allow-column-reordering="true"
        :height="gridHeight"
        :row-alternation-enabled="true"
        :focused-row-enabled="true"
        key-expr="품번"
        :column-auto-width="true"
        :auto-navigate-to-focused-row="false"
        @toolbar-preparing="onToolbarPreparing"
        @cell-prepared="onCellPreparedOutput"
      >
        <DxSearchPanel :visible="true" placeholder="검색..." />
        <DxExport :enabled="true" :file-name="exportTitle" />
        <DxFilterRow :visible="true" apply-filter="auto" />
        <DxColumnFixing :enabled="false" />
        <DxColumn
          :allowEditing="false"
          caption="고객사"
          data-field="입고업체"
          width="120"
        >
          <DxLookup
            :data-source="$store.getters.getCustomerInfo"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing="false"
          :caption="$store.getters.getGroupName"
          data-field="차종"
          :min-width="50"
        >
          <DxLookup
            :data-source="차종리스트"
            display-expr="차종"
            value-expr="차종"
          />
        </DxColumn>
        <DxColumn :allowEditing="false" caption="품번" data-field="품번">
        </DxColumn>
        <DxColumn
          :allowEditing="false"
          caption="품명"
          data-field="품명"
          :visible="true"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="재질"
          data-field="재질"
          :visible="true"
        >
          <DxLookup
            :data-source="재질리스트"
            display-expr="재질"
            value-expr="재질"
          />
        </DxColumn>
        <DxColumn caption="원자재" alignment="center">
          <DxColumn
            :allowEditing="true"
            caption="두께"
            data-field="자사두께"
            :visible="true"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="가로"
            data-field="자사가로"
            :visible="true"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="세로"
            data-field="자사세로"
            :visible="true"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="RM중량"
            data-field="자사중량"
            :visible="true"
            dataType="number"
            format="#,##0.000"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="단가"
            data-field="단가금액"
            :visible="true"
            format="#,##0"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="NET"
            data-field="자사net"
            :visible="true"
            format="#,##0.000"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="수율"
            data-field="수율"
            :visible="true"
            format="#,##0.00"
          >
          </DxColumn>
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="생산처"
          data-field="거래처코드"
          :visible="true"
          alignment="center"
        >
          >
          <DxLookup
            :data-source="partnersLookupInfo"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="계획수량"
          :calculate-cell-value="calcPlanQty"
          :visible="true"
          format="#,##0"
        >
        </DxColumn>
        <DxColumn caption="원자재현황" alignment="center">
          <DxColumn
            :allowEditing="true"
            caption="계획중량"
            data-field="계획중량"
            :visible="true"
            format="#,##0"
          >
          </DxColumn>
          <DxColumn caption="소요량" alignment="center">
            <DxColumn
              :allowEditing="true"
              caption="전월재고"
              :calculate-cell-value="calcStock"
              :visible="true"
              format="#,##0"
            >
            </DxColumn>
            <DxColumn
              :allowEditing="true"
              caption="필요량"
              data-field="필요량"
              :calculate-cell-value="calcNeedStock"
              :visible="true"
              format="#,##0"
            >
            </DxColumn>
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            caption="입고중량"
            data-field="입고중량"
            :visible="true"
            format="#,##0"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            caption="현재고(당월)"
            data-field="현재고"
            :visible="true"
            format="#,##0"
          >
          </DxColumn>
          <DxColumn caption="금액" alignment="center">
            <DxColumn
              :allowEditing="true"
              caption="계획"
              data-field="계획금액"
              :visible="true"
              format="#,##0"
            >
            </DxColumn>
            <DxColumn
              :allowEditing="true"
              caption="입고"
              data-field="입고금액"
              :visible="true"
              format="#,##0"
            >
            </DxColumn>
          </DxColumn>
        </DxColumn>
        <DxMasterDetail :enabled="true" template="coilOutputDetailTemplate" />
        <DxSummary>
          <DxTotalItem
            value-format="#,##0"
            column="차종"
            display-format="{0} (건)"
          />
          <DxTotalItem
            value-format="#,##0"
            summary-type="sum"
            column="계획금액"
            display-format="{0} 원"
          />
          <DxTotalItem
            value-format="#,##0"
            summary-type="sum"
            column="입고금액"
            display-format="{0} 원"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="계획중량"
            display-format="{0} Kg"
          />
        </DxSummary>
        <template #coilOutputDetailTemplate="{ data: item }">
          <CoilInputDetailTemp
            :item="item"
            :thisYear="thisYear"
            :thisMonth="thisMonth"
          />
        </template>
        <dx-paging :enabled="false" />
        <dx-scrolling
          mode="virtual"
          showScrollbar="always"
          :useNative="false"
        />
        <dx-sorting mode="multiple" />
      </dx-data-grid>
    </div>
    <loading
      :active.sync="isLoading"
      color="rgb(2, 110, 156)"
      loader="bars"
    ></loading>
  </div>
  <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, {
  DxScrolling,
  DxFilterRow,
  DxColumnFixing,
  DxTotalItem,
  DxMasterDetail,
  DxSummary,
  DxColumn,
  DxPaging,
  DxSorting,
  DxSearchPanel,
  DxExport,
  DxLookup
} from 'devextreme-vue/data-grid'
import CoilInputDetailTemp from './CoilInputDetailTemp'
export default {
  name: 'CoilPlanAndDailyInput',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      coilPlanAndInputInfo: null,
      exportTitle: null,
      yearArray: [],
      thisYear: null,
      monthArray: [],
      thisMonth: null,
      selectBoxVendorOptions: [],
      selectedVendor: 'ALL',
      currentMonth: null,
      차종리스트: [],
      재질리스트: [],
      partnersLookupInfo: null
    }
  },
  props: {},
  computed: {},
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport,
    DxLookup,
    DxMasterDetail,
    CoilInputDetailTemp
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.init()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {},
  beforeDestroy: function () {},
  methods: {
    calcStock (row) {
      let 전월재고
      if (row.이월재공 <= 0) {
        전월재고 = 0
      } else {
        전월재고 = row.이월재공
      }
      return 전월재고
    },
    calcNeedStock (row) {
      let 전월재고
      let 필요량 = 0
      if (row.계획중량 > 0) {
        if (row.이월재공 <= 0) {
          전월재고 = 0
        } else {
          전월재고 = row.이월재공
        }
        필요량 = row.계획중량 - 전월재고
      }
      return 필요량
    },
    calcPlanQty (row) {
      return row.계획중량 / row.자사중량
    },
    init () {
      this.thisYear = AppLib.getThisYear()
      for (let i = this.thisYear; i >= 2021; i--) {
        this.yearArray.push({ year: i })
      }
      this.thisMonth = AppLib.getThisMonth()
      this.currentMonth = `${AppLib.getThisMonth()}`
      for (let i = 1; i <= 12; i++) {
        if (i > 0 && i < 10) {
          this.monthArray.push({ name: i + '월', value: '0' + i })
        } else {
          this.monthArray.push({ name: i + '월', value: '' + i })
        }
      }
      this.selectBoxVendorOptions = this.$Q.extend(
        true,
        [],
        this.$_.sortBy(this.$store.getters.getFirstVendor, '거래처명')
      )
      this.selectBoxVendorOptions.unshift({
        거래처명: 'ALL',
        거래처코드: 'ALL'
      })
      this.selectBoxVendorOptions.push({
        거래처명: '시중구매',
        거래처코드: '시중구매'
      })
      this.refreshPlanInputDataGrid(
        this.thisYear,
        this.thisMonth,
        this.selectedVendor
      )
    },
    onCellPreparedOutput (e) {},
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: args => {
              this.thisYear = args.value
              this.refreshPlanInputDataGrid(
                this.thisYear,
                this.thisMonth,
                this.selectedVendor
              )
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.monthArray,
            valueExpr: 'value',
            displayExpr: 'name',
            value: this.thisMonth,
            onValueChanged: args => {
              this.thisMonth = args.value
              this.refreshPlanInputDataGrid(
                this.thisYear,
                this.thisMonth,
                this.selectedVendor
              )
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>거래처 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 100,
            items: this.selectBoxVendorOptions,
            valueExpr: '거래처코드',
            displayExpr: '거래처명',
            value: this.selectedVendor,
            onValueChanged: args => {
              this.selectedVendor = args.value
              this.refreshPlanInputDataGrid(
                this.thisYear,
                this.thisMonth,
                this.selectedVendor
              )
            }
          }
        }
      )
    },
    refreshPlanInputDataGrid (year, month, vendor) {
      // this.isLoading = true
      console.log(year + '--' + month)
      this.exportTitle = `${this.thisYear}-${this.thisMonth}-계획대비입고내역서`
      const param = {
        startDate: `${year}-${month}-01`,
        endDate: `${year}-${month}-${AppLib.getMonthLastDay(year, month)} 23:59:59`,
        거래처코드: this.selectedVendor
      }
      this.$_sp
        .runNoEncodeFindProc('spFindAllCoilPlanAndInputQtyByDateAndVendorCodeV2', param)
        .then(data => {
          this.isLoading = false
          this.coilPlanAndInputInfo = this.$_sp.MakeModel(data)
          console.log(this.coilPlanAndInputInfo)
          this.차종리스트 = AppLib.getGroupByList(this.$_, this.coilPlanAndInputInfo, '차종')
          this.재질리스트 = AppLib.getGroupByList(this.$_, this.coilPlanAndInputInfo, '재질')
          this.partnersLookupInfo = AppLib.getGroupByLookupCompany(this.$_, this.coilPlanAndInputInfo, '거래처코드', this.$store.getters.getPartnersInfo)
          // this.searchEmptyPressSize(this.coilPlanAndInputInfo)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    searchEmptyPressSize (coilInfo) {
      const where = this.$_.where(coilInfo, { 자사두께: null })
      console.log(where)
      let param = null
      where.forEach(item => {
        param = {
          품번: item.품번
        }
        this.$_sp
          .runNoEncodeFindProc('spFindAllPressSizeByCoilCode', param)
          .then(data => {
            const result = this.$_sp.MakeModel(data)
            if (result.length > 0) {
              item.자사두께 = result[0].자사두께
              item.자사가로 = result[0].자사가로
              item.자사세로 = result[0].자사세로
              item.자사중량 = result[0].자사중량
              item.자사net = result[0].자사net
              item.수율 = (item.자사net / item.자사중량) * 100
            }
          })
      })
    }
  }
}
</script>

<style lang="scss"></style>
